import { render, staticRenderFns } from "./results-board-join.vue?vue&type=template&id=5ac6bb9a&scoped=true&"
import script from "./results-board-join.vue?vue&type=script&lang=ts&"
export * from "./results-board-join.vue?vue&type=script&lang=ts&"
import style0 from "./results-board-join.vue?vue&type=style&index=0&id=5ac6bb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac6bb9a",
  null
  
)

export default component.exports